module.exports = __webpack_public_path__ + "static/swimming-pool-2b796ebd720ccb8bca011210e546574b.png";